import React, { useState } from "react";
import './index.scss';
import styled from "styled-components"
import SectionHeader from "../SectionHeader";
import { ROUTE_PATH } from "@/utils/Global";
import i18n from "@/i18n";

const TemplateItemWrapper = styled.article`
    border-radius: 10px;
    background-color: #515151;
    display: flex;
    min-width: 216px;
    max-width: 216px;
    min-height: 384px;
    max-height: 384px;
    flex-direction: column;
    overflow: hidden;
    justify-content: end;
    flex: 1;
    flex-basis: 0%;
    cursor: pointer;

    transition: 0.5s;
    &:hover {
        transform: scale(1.05);
    }
`

const TemplateThumbnail = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`

const TemplateVideo = styled.video`
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
    border-radius: 8px;
`

const TemplateWrapper = styled.section`
    display: flex;
    max-width: 100%;
    align-items: start;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
`

function TemplateItem({ id, thumbnail, src, onThumbnailClicked }) {
    const [isLoaded, setIsLoaded] = useState(false)
    return (
        <TemplateItemWrapper
            onClick={onThumbnailClicked(id)}
        >
            <TemplateVideo
                src={src}
                muted
                autoPlay
                loop
                playsInline
                webkit-playsinline
                onLoadedData={() => {
                    setIsLoaded(true)
                }}
            />
            <TemplateThumbnail
                style={{
                    display: isLoaded ? "none" : "block"
                }}
                src={thumbnail}
            />
        </TemplateItemWrapper>
    )
}

const TemplateToVideoSection = ({ onThumbnailClicked, lang, history }) => {
    const templates_ko = [
        {
            "id": "66dacb61bd5c7d3be678dbb1",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/66dacb61bd5c7d3be678dbb1.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/66dacb61bd5c7d3be678dbb1.mp4"
        },
        {
            "id": "6228b6b6f0a7200350019ed0",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/6228b6b6f0a7200350019ed0.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/6228b6b6f0a7200350019ed0.mp4"
        },
        {
            "id": "64fae54b9f720400609b36ba",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/64fae54b9f720400609b36ba.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/64fae54b9f720400609b36ba.mp4"
        },
        {
            "id": "667543189161d30793a21c03",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/667543189161d30793a21c03.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/667543189161d30793a21c03.mp4"
        },
        {
            "id": "657c92bb3b57062c5a4b0a94",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/657c92bb3b57062c5a4b0a94.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/657c92bb3b57062c5a4b0a94.mp4"
        },
        // {
        //     "id": "61317acc9eaaac05d6b963aa",
        //     "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/61317acc9eaaac05d6b963aa.jpg",
        //     "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/61317acc9eaaac05d6b963aa.mp4"
        // },
    ]
    const templates_en = [
        {
            "id": "61317acc9eaaac05d6b963aa",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/61317acc9eaaac05d6b963aa_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/61317acc9eaaac05d6b963aa_en.mp4"
        },
        {
            "id": "6228b6b6f0a7200350019ed0",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/6228b6b6f0a7200350019ed0_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/6228b6b6f0a7200350019ed0_en.mp4"
        },
        {
            "id": "64fae54b9f720400609b36ba",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/64fae54b9f720400609b36ba_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/64fae54b9f720400609b36ba_en.mp4"
        },
        {
            "id": "657c92bb3b57062c5a4b0a94",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/657c92bb3b57062c5a4b0a94_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/657c92bb3b57062c5a4b0a94_en.mp4"
        },
        {
            "id": "667543189161d30793a21c03",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/667543189161d30793a21c03_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/667543189161d30793a21c03_en.mp4"
        },
        // {
        //     "id": "66dacb61bd5c7d3be678dbb1",
        //     "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/66dacb61bd5c7d3be678dbb1_en.jpg",
        //     "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/66dacb61bd5c7d3be678dbb1_en.mp4"
        // }
    ]
    const templates = lang === "ko" ? templates_ko : templates_en

    const handleClickItem = (routePath) => {
        history.push(routePath)
    }

    return (
        <div className="template-to-video-section-wrapper">
            <SectionHeader 
                title="Template to Video" 
                descriptions={[
                    i18n.t("web.pc.landing.2025.template.description.1"), 
                    i18n.t("web.pc.landing.2025.template.description.2")
                ]}
                onClickButton={() => handleClickItem(ROUTE_PATH.DESIGN_SELECT)}
            />
            <TemplateWrapper>
                {templates.map(item => (
                    <TemplateItem
                        id={item.id}
                        thumbnail={item.thumbnail}
                        src={item.src}
                        onThumbnailClicked={onThumbnailClicked}
                    />
                ))}
            </TemplateWrapper>
        </div>
    )
}

export default TemplateToVideoSection;